// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"d3737976","453":"39243f2b","563":"e463bc43"}[chunkId] + ".chunk.js";
};